var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled } from 'styled-components';
import { BarChart } from './BarChart';
import { PieChart } from './PieChart';
import { SkillsReportEvents, useSkillsReportAnalytics, } from '../../../hooks/useSkillsReportAnalytics';
var ScWrapper = styled.div.withConfig({ displayName: "ScWrapper", componentId: "sc-72dutd" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n"], ["\n  width: 100%;\n  text-align: center;\n"])));
var Charts = function (_a) {
    var hasOnlyPKStudents = _a.hasOnlyPKStudents, onClick = _a.onClick, rest = __rest(_a, ["hasOnlyPKStudents", "onClick"]);
    var sendGaEvent = useSkillsReportAnalytics();
    var handleDomainClick = React.useCallback(function (domainName) {
        sendGaEvent(SkillsReportEvents.diagramsDomainClick);
        onClick({ domainName: domainName });
    }, [sendGaEvent]);
    var handleGradeClick = React.useCallback(function (domainName, gradeName) {
        sendGaEvent(SkillsReportEvents.diagramsGradeClick);
        onClick({ domainName: domainName, gradeName: gradeName });
    }, [sendGaEvent]);
    return (_jsx(ScWrapper, { children: hasOnlyPKStudents ? (_jsx(PieChart, __assign({}, rest, { onClick: onClick, onDomainClick: handleDomainClick }), void 0)) : (_jsx(BarChart, __assign({}, rest, { onClick: onClick, onDomainClick: handleDomainClick, onGradeClick: handleGradeClick }), void 0)) }, void 0));
};
export { Charts };
var templateObject_1;
